import type { VideoUpload } from './evaluationService';

const ACTIVE_RUN_STATUSES = new Set(['queued', 'running']);

export function isAiScoringAssistEnabled(): boolean {
  return process.env['REACT_APP_AI_SCORING_ASSIST'] !== 'false';
}

export function isRunActive(status: string): boolean {
  return ACTIVE_RUN_STATUSES.has(status.toLowerCase());
}

/** Prefer the newest processed lesson video for transcription. */
export function pickTranscriptionVideoId(
  videos: VideoUpload[]
): number | null {
  const processed = videos.filter(v => v.status === 'processed');
  if (processed.length === 0) return null;

  processed.sort((a, b) => {
    const ta = a.processed_at ? Date.parse(a.processed_at) : 0;
    const tb = b.processed_at ? Date.parse(b.processed_at) : 0;
    return tb - ta;
  });
  return processed[0]?.id ?? null;
}

export function runStatusLabel(status: string): string {
  switch (status.toLowerCase()) {
    case 'queued':
      return 'Queued';
    case 'running':
      return 'Transcribing';
    case 'completed':
      return 'Transcript ready';
    case 'failed':
      return 'Failed';
    default:
      return status;
  }
}
